import React from 'react'
import { Tooltip } from 'components/Form'

const FactoredPercentAccuracyTooltip = (props) => {
    const { title = "שגיאות שאינן פוגמות בהבנת הטקסט משוקללות כמילים קבילות (לדוגמא - מילים עם היסוס, חזרה ותיקון עצמי, וכן מילים עם שגיאה קלה כמו השמטת דגש)" } = props

    return (
        <Tooltip title={title} />
    )
}

export default FactoredPercentAccuracyTooltip